"use strict";

define('uikit/elements/select',['underscore', 'marionette', '../mixins/component.mixin', '../channel', '../templates', 'select2'], function (_, Mn, ComponentMixin, channel) {
  var Select = Mn.ItemView.extend(ComponentMixin).extend({
    _PAGE_SIZE: 20,
    _select2: null,
    template: _.template('<select></select>'),
    value: null,
    events: {
      'keydown .select2-selection__clear': function keydown_Select2Selection__clear(e) {
        if (13 === e.keyCode) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this._select2.val(null).trigger('change');
          this.value = null;
        }
      }
    },
    options: {
      text: '',
      formatter: null,
      placeholder: '',
      allowClear: true,
      width: '100%',
      ajaxResultProcessor: null,
      ajaxURL: null,
      data: null,
      onSelected: null
    },
    serializeData: function serializeData() {
      var data = ComponentMixin.serializeData.apply(this, arguments);
      if (_.isFunction(this.formatter)) {
        data.text = this.formatter(this.text);
      }
      return data;
    },
    updateAttributes: function updateAttributes() {
      this.addClass(this.getOption('color'), this.getBoolOption('color'));
    },
    focus: function focus() {
      this.$el.focus();
    },
    onRender: function onRender() {
      this._select2 = this.$el.find('select').select2({
        debug: true,
        placeholder: this.placeholder,
        allowClear: this.allowClear,
        width: this.width,
        minimumResultsForSearch: this._PAGE_SIZE,
        language: {
          searching: function searching() {
            return "Searching...";
          },
          loadingMore: function loadingMore() {
            return "Getting more results...";
          }
        },
        ajax: {
          url: this.ajaxURL,
          delay: 250,
          data: function (params) {
            return {
              search: params.term,
              page: params.page - 1 || 0,
              size: this._PAGE_SIZE
            };
          }.bind(this),
          processResults: function (data) {
            window.setTimeout(function () {
              var select2SearchBox = $('.select2-search');
              var organizationTitle = $(".select2-container").find('.select2-results__option--highlighted').first().text();
              if (select2SearchBox.hasClass('select2-search--hide')) {
                var select2wrapper = $('.select2-selection');
                select2wrapper.removeAttr('aria-labelledby');
                select2wrapper.attr('aria-label', organizationTitle);
                select2wrapper.focus();
              } else {
                var select2searchInput = $('.select2-search__field');
                select2searchInput.removeAttr('aria-labelledby');
                select2searchInput.attr('aria-label', organizationTitle);
                select2searchInput.focus();
              }
            }, 500);
            return this.ajaxResultProcessor(data);
          }.bind(this)
        },
        data: this.data
      }).on("select2:open", function () {
        var container = $('.select2-container');
        container.on('keydown', function (e) {
          switch (e.keyCode) {
            case 9:
              $(e.target).removeAttr('aria-label');
              break;
            case 38:
            case 40:
              var highlighted = container.find('.select2-results__option--highlighted').first();
              $(e.target).attr('aria-label', highlighted.text());
              $(e.target).removeAttr('aria-labelledby');
              break;
            default:
              break;
          }
        });
      }.bind(this)).on("select2:selecting", function (e) {
        var data = e.params.args.data;
        this.value = data;
        if (this.onSelected) {
          this.onSelected(data);
        }
      }.bind(this)).on("select2:select", function () {
        window.setTimeout(function () {
          var clearButton = $('.select2-selection__clear');
          $(clearButton).attr('tabindex', '0');
          $(clearButton).attr('role', 'button');
          $(clearButton).attr('aria-label', 'Remove all items');
        }, 500);
      }.bind(this)).on("select2:unselect", function () {
        this.value = null;
      }.bind(this));
    }
  });
  channel.reply('select', function () {
    return Select;
  });
  return Select;
});

